import { useCallback, createRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { APP_URLS } from 'resources/urls'

const isHandledRef = createRef()

const useSignInRedirect = () => {
  const history = useHistory()
  const location = useLocation()

  const handleSignInRedirect = useCallback(() => {
    if (isHandledRef.current) {
      return
    }
    isHandledRef.current = true

    const pathname = location.state?.from?.pathname || APP_URLS.REKLAIM

    history.push(pathname)
  }, [history, location.state])

  const resetIsHandled = useCallback(() => {
    isHandledRef.current = false
  }, [])

  return [handleSignInRedirect, resetIsHandled]
}

export default useSignInRedirect
